// extracted by mini-css-extract-plugin
export default {"container":"Single_container__363rK"};